export default __webpack_public_path__ + "static/media/calendar.990d6fe4.svg";